import type { Components, Theme } from '@mui/material';

export const paperCustomizations: Components<Theme> = {
  MuiPaper: {
    defaultProps: {
      elevation: 0,
      variant: 'outlined',
    },
    styleOverrides: {
      outlined: ({ theme }) => ({
        borderColor: theme.palette.grey[200],
      }),
    },
  },
};
